import { FC, useCallback, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';

import { Conversation } from 'components/features/Conversation';
import { ButtonLink } from 'components/parts/ButtonLink';

import styles from './Ending.module.scss';

import { EndRoll } from './components/EndRoll';
import { Screen } from './components/Screen';

export const Ending: FC = () => {
  const navigate = useNavigate();
  // const { data: progressData } = useGetProgressData();
  // const receivedPerfect = progressData ? progressData?.rewardList.includes('perfect') : false;
  usePageTitle(`エンディング`);

  const [step, setStep] = useState(1);

  const handleNextStep = useCallback(() => {
    setStep(prev => prev + 1);
  }, []);

  const handleSkipTalk = useCallback(() => {
    setStep(9);
  }, []);

  const handleSkipEndRoll = useCallback(() => {
    setStep(10);
  }, []);

  if (step === 1) {
    return (
      <Screen onNextStep={handleNextStep} onSkipDialogue={handleSkipTalk} screen="home">
        <figure className={styles.figure}>
          <img src={require('./images/img_members-1.webp')} alt="" width="343" height="230" />
        </figure>
        <p className={styles.dialogueTextRoot}>
          ついに、あなたは福島に隠されたすべての宝を集めました。レッド・カウの基地へ戻ったあなたは、仲間たちといっしょに宝を机の上へそっと並べます。
        </p>
      </Screen>
    );
  }

  if (step === 2) {
    return (
      <Screen onNextStep={handleNextStep} onSkipDialogue={handleSkipTalk}>
        <div className={styles.dialogueMessage}>
          <Conversation role="chara-talk">
            これで、本当に空の国への道が分かるのかな……？
          </Conversation>
        </div>
      </Screen>
    );
  }

  if (step === 3) {
    return (
      <Screen onNextStep={handleNextStep} onSkipDialogue={handleSkipTalk} screen="home">
        <figure className={styles.figure}>
          <img src={require('./images/img_members-2.webp')} alt="" width="343" height="230" />
        </figure>
        <p className={styles.dialogueTextRoot}>
          どきどきしながら見つめていると、宝の一つひとつが、
          <br />
          ふわりとあたたかな光をまといはじめました。
        </p>
      </Screen>
    );
  }

  if (step === 4) {
    return (
      <Screen onNextStep={handleNextStep} onSkipDialogue={handleSkipTalk}>
        <figure className={styles.figure}>
          <img src={require('./images/img_light.webp')} alt="" width="343" height="230" />
        </figure>
        <p className={styles.dialogueTextRoot}>
          やがて、いくつもの光は机の上で重なり合い、一つの大きな光となりました。
          <br />
          まばゆい光は、まるで道を教えるように、まっすぐ空へ向かってのびていきます。
        </p>
      </Screen>
    );
  }

  if (step === 5) {
    return (
      <Screen onNextStep={handleNextStep} onSkipDialogue={handleSkipTalk} screen="sky">
        <figure className={styles.figure}>
          <img src={require('./images/img_telescope.webp')} alt="" width="343" height="230" />
        </figure>
        <p className={styles.dialogueTextRoot}>
          あなたは急いで望遠鏡をのぞき込みました。すると、遠くの空の向こうに、雲に包まれた大きなお城のようなものが見えたのです。
        </p>
      </Screen>
    );
  }

  if (step === 6) {
    return (
      <Screen onNextStep={handleNextStep} onSkipDialogue={handleSkipTalk} screen="skyland">
        <div className={styles.dialogueMessage}>
          <Conversation role="chara-surprized">空の国だ！　本当にあったんだ！</Conversation>
        </div>
      </Screen>
    );
  }

  if (step === 7) {
    return (
      <Screen onNextStep={handleNextStep} onSkipDialogue={handleSkipTalk} screen="sky">
        <figure className={styles.figure}>
          <img src={require('./images/img_go.webp')} alt="" width="343" height="230" />
        </figure>
        <p className={styles.dialogueTextRoot}>
          あなたはすぐに準備を整え、光の道しるべを目印に、大きく広がる空へと出発しました。
        </p>
      </Screen>
    );
  }

  if (step === 8) {
    return (
      <Screen screen="sky" onNextStep={handleNextStep} onSkipDialogue={handleSkipEndRoll}>
        <div className={styles.bookRoot}>
          <img
            src={require('./images/book.webp')}
            alt="みんなの胸が、熱くなるのを感じました。人々を助け、つないできた絆が、今、福島を未来へ導く力になる――。月日が流れ、アマナたちの姿は少しずつ歴史の中に溶けていきました。"
            className={styles.book}
            width="367"
            height="548"
          />
        </div>

        <div className={styles.closeButtonRoot}>
          <ButtonLink text="本を閉じる" href="#" />
        </div>
      </Screen>
    );
  }

  if (step === 9) {
    // 視差効果が有効であれば10秒後に、無効であれば5秒ごに自動で次のステップに進む
    const isReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    console.log({ isReduce });
    setTimeout(
      () => {
        setStep(prev => {
          if (prev === 9) {
            return 10;
          }
          return prev;
        });
      },
      isReduce ? 5000 : 10500
    );
    return (
      <Screen screen="sky" onNextStep={handleNextStep} onSkipDialogue={handleSkipEndRoll}>
        <EndRoll />
      </Screen>
    );
  }

  if (step === 10) {
    return (
      <Screen
        isSkip={false}
        screen="sky"
        onNextStep={handleSkipEndRoll}
        onSkipDialogue={handleSkipEndRoll}
      >
        <div className={styles.ending}>
          <div className={styles.clearImageRoot}>
            <img
              src={require('./images/clear.webp')}
              alt="Congratulations"
              className={styles.clearImage}
              width="375"
              height="313"
            />
          </div>
          <p className={styles.endingParagraph}>おめでとうございます！</p>
          <p className={styles.endingParagraph}>
            あなたは福島に隠されたすべての宝を見つけ、空の国への道しるべを見つけ出しました。
          </p>
          <p className={styles.endingParagraph}>
            レッド・カウの一員として成しとげた空の国への冒険は、語り継がれるものになるでしょう。
          </p>
          <p className={styles.endingParagraph}>今回のあなたとレッド・カウの冒険はここまで。</p>
          <p className={styles.endingParagraph}>また次の冒険でお会いしましょう！</p>
          {/* <div className={styles.perfectButton}>
            <ButtonLink
              text={receivedPerfect ? '受け取り済みです' : 'パーフェクト賞をもらう'}
              handleClick={() => navigate('/reward/perfect')}
              href="#"
              disabled={receivedPerfect ? true : false}
            />
          </div> */}
          <div className={styles.homeButton}>
            <ButtonLink text="ホームに戻る" handleClick={() => navigate('/home')} href="#" />
          </div>
        </div>
      </Screen>
    );
  }

  return <div>エピローグ完了</div>;
};
